// @ts-nocheck
import * as React from 'react'
import { renderRoutes } from 'react-router-config'
import { withStyles, WithStyles } from '@zn-material-ui'
import { withSnackbar, withSnackbarProps } from 'notistack'
import { observer, inject } from 'mobx-react'
import Store from 'store'
import { isDingTalk } from '@utils'
import classnames from 'classnames'
import homeStyles from './styles/HomeStyle'
import Menu from './components/Menu'
import Right from './components/Right'
import { Homes } from '@services/api'
import DataTracker from '@common/dataTracker'
import { RouteComponentProps } from 'react-router'
import { IRouteInterface } from '@src/routes/interface'

import AppBar from '@components/AppBar'
const LIVE_LIST = /\/home\/livelist\/(1|2)/
const EXAM_LIBRARY = /\/home\/examLibrary\//
const NeedMenuRouteList = [
  '/home/course',
  LIVE_LIST,
  '/home/liteVideo',
  '/home/homePage',
  '/home/trainingClass',
  '/home/inforList',
  '/home/KnowledgeLib',
  '/home/publicExam',
  '/home/communicateCenter',
  EXAM_LIBRARY,
]

export interface IProps
  extends WithStyles<typeof homeStyles>,
    withSnackbarProps,
    RouteComponentProps {
  route?: IRouteInterface
  UserStore?: any
  HomeState?: any
}

export interface IState {
  pushMessage: string;
  courseCount: string;
  homeWorkCount: string;
  examCount: string;
  confirmDialogVisbile: boolean;
  studyMapCount: string;
  classCount: string;
  practicalContent: string;
  questionCount: string,
  newQuestionnaireCount: string
}

@inject('UserStore', 'HomeState')
@observer
class Home extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      pushMessage: 'N',
      courseCount: '0',
      examCount: '0',
      confirmDialogVisbile: false,
      studyMapCount: '0',
      classCount: '0',
      practicalContent:'0',
      questionCount: '0',
      newQuestionnaireCount: '0',
      homeWorkCount: '0',
    }
  }

  public componentDidMount() {
    const { HomeState, UserStore } = this.props
    const operationList = UserStore.operationList || Store.get('operationList')
    this.getAllNewContent()
    this.getPracticalContent()
    this.getIsDingDing()
    DataTracker.startTrackEvent()
    HomeState.queryHomeChannelModule(UserStore.homeId)
    UserStore.setOperationList(operationList)
  }

  public componentWillReceiveProps(nextProps: IProps) {
    if (this.props.location !== nextProps.location) {
      this.getAllNewContent()
      this.getPracticalContent()
    }
  }

  public componentWillUnmount() {
    DataTracker.stopTrackEvent()
  }

  public render() {
    const { classes, route, UserStore } = this.props
    const {
      // pushMessage,
      courseCount,
      homeWorkCount,
      examCount,
      studyMapCount,
      classCount,
      practicalContent,
      newQuestionnaireCount,
      questionCount
    } = this.state
    const isNeedMenu = this.getIsNeedMenu()
    const operationList = UserStore.operationList || Store.get('operationList')
    const hasOrg = Store.get('hasOrg') || false
    return (
      <div className={classnames(classes.home)}>
        <AppBar />
        <div
          className={classes.routeChildrenWrap}
          style={this.props.HomeState.style}
        >
          {isNeedMenu && hasOrg && (
            <Menu
              route={this.props.route}
              location={this.props.location}
              operationList={operationList}
              UserStore={UserStore}
            />
          )}
          <div
            style={{ minWidth: '760px', ...this.props.HomeState.childrenStyle }}
          >
            {renderRoutes(route && route.children)}
          </div>
          {isNeedMenu && (
            <Right
              courseCount={courseCount}
              examCount={examCount}
              studyMapCount={studyMapCount}
              practicalContent={practicalContent}
              classCount={classCount}
              fetchMore={this.fetchMore}
              operationList={operationList}
              enqueueSnackbar={this.props.enqueueSnackbar}
              questionCount={questionCount}
              newQuestionnaireCount={newQuestionnaireCount}
            />
          )}
        </div>
      </div>
    )
  }

  private getIsNeedMenu = () => {
    const { pathname } = this.props.location
    return NeedMenuRouteList.some((path: any) => {
      if (typeof path === 'string') {
        return pathname === path
      } else if (path instanceof RegExp) {
        return path.test(pathname)
      }
      return false
    })
  }

  private getAllNewContent = () => {
    const cacheLv = Store.get("Lv")
    const cacheMessageLv = Store.get("messageLv")
    let { lv, messageLv } = this.props.UserStore
    lv = !!lv ? lv : cacheLv
    messageLv = !!messageLv ? messageLv : cacheMessageLv
    Homes.getAllNewContent(lv, messageLv)
      .then((res: any) => {
        if (res.code !== 0) {
          global.$message(res.message)
          return
        }
        const { examCount, courseCount, pushMessage, studyMapCount, classCount,
          questionCount, newQuestionnaireCount, homeWorkCount } = res.body
        this.setState({ courseCount, examCount, pushMessage, studyMapCount, classCount,
          questionCount, newQuestionnaireCount, homeWorkCount })
        const now = new Date().getTime()
        Store.set("Lv", now)
        Store.set("messageInfo", { pushMessage })
        this.props.HomeState.changePushMessage(pushMessage)
        this.props.UserStore.setLv(now)
      })
  }

  private getPracticalContent = () => {
    Homes.getPracticalContent().then((res: any) => {
      if (res.code === 0) {
        const { body } = res
        this.setState({ practicalContent: body })
      }
    })
  }

  private getIsDingDing = () => {
    const dingdingOpen: Window | null = window.open
    if (isDingTalk && dingdingOpen) {
      window.open = (url) => dingdingOpen(url, '_self')
    }
  }

  private fetchMore = () => {
    this.props.history.push({ pathname: `/home/learnRecord` })
  }
}

export default withStyles(homeStyles)(withSnackbar(Home))
